import { useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchAccessToken } from "../../api/auth";
import { removeAuth } from "../../redux/actions/auth/authActions";
import store from "../../redux/reduxStore";

const AuthGuard = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const isLogged = localStorage.getItem("logged");

  const access_token = auth?.access_token;

  useEffect(() => {
    if (!access_token && isLogged) {
      (async () => {
        try {
          // to get a clear undestanding of whats happing here , plz study both fetchAccessToken function and the auth guard
          await fetchAccessToken();
        } catch (error) {
          const message = error?.response?.data?.error?.message;
          store.dispatch(removeAuth({ message }));
        }
      })();
    }
  }, [access_token, isLogged]);

  return children;
};

export default AuthGuard;
